import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-rfebm-secondary-button',
  templateUrl: 'rfebm-secondary-button.component.html',
  styleUrls: ['rfebm-secondary-button.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class RfebmSecondaryButtonComponent {

  @Input() isDisabled: boolean = false;

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  protected handleClick(): void {
    if (!this.isDisabled) {
      this.onClick.emit();
    }
  }

}
